module.exports = __webpack_public_path__ + "static/adambeyer_2-e3f7459707a4542b81e15bd7abcbe4b4.jpg";